let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kEIUB")).then(() => parcelRequire('gqAVe'));